import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

import { BillService } from '../../../services/accounting/bill.service';

declare var jQuery: any;
declare var moment: any;

@Component({
  selector: 'app-bill-index',
  templateUrl: './bill-index.component.html',
  styleUrls: ['./bill-index.component.css'],
})
export class BillIndexComponent implements OnInit {
  @Input() matter_id: number;

  search_options: any = {
    bill_types: [],
    per_page: 30,
  };

  datePickerLabel: string;

  count: number = 0;

  search_params: any = {
    amount: 0,
    amount_comparison: '',
    bill_type_id: '',
    page: 1,
    per_page: 30,
  };

  bills: Array<any> = [];

  loading: boolean = true;

  searching: boolean = false;

  constructor(private billService: BillService) {}

  // Component lifecycle events
  ngOnInit() {
    let scope: BillIndexComponent = this;
    jQuery('#reportrange').daterangepicker(
      {
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          'Last 7 Days': [moment().subtract(6, 'days'), moment()],
          'Last 30 Days': [moment().subtract(29, 'days'), moment()],
          'This Month': [moment().startOf('month'), moment().endOf('month')],
          'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        },
      },
      (start: any, end: any, label: any) => {
        this.datePickerLabel = `${start.format('MM/DD/YYYY')} - ${end.format('MM/DD/YYYY')}`;
        this.search_params.start_date = start.format('MM/DD/YYYY');
        this.search_params.end_date = end.format('MM/DD/YYYY');
      }
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.matter_id && changes.matter_id.currentValue)
      this.billService.getSearchOptions({ matter_id: this.matter_id }).then((response_json) => {
        this.search_options = response_json;
        this.search_params.per_page = response_json.per_page;
        this.loadBills();
      });
  }

  // Component methods
  backToBills() {}

  loadBills(pageEvent: any = null) {
    if (pageEvent) this.search_params.page = pageEvent.page;
    this.searching = true;
    this.search_params.matter_id = this.matter_id;
    this.billService
      .getBills(this.search_params)
      .then((response_json) => {
        this.searching = false;
        this.count = response_json.count;
        this.bills = response_json.bills;
        this.loading = false;
      })
      .catch(() => {
        this.searching = false;
      });
  }

  resetSearch() {
    this.datePickerLabel = '';
    this.search_params = {
      amount: 0,
      amount_comparison: '',
      bill_type_id: '',
      page: 1,
      per_page: this.search_options.per_page,
    };
    this.loadBills();
  }

  showInvoice(invoice_id: number) {}
}
